import React, { useEffect } from "react";
import "./FriendActionModal.css"; // or a separate popup CSS
import { useDispatch, useSelector } from "react-redux";
import {
  setShowBlockPopup,
  resetFriendModalState,
} from "../../redux/slicers/friendModalSlicer";
import { SERVER_URL } from "../../api/client";
import {
  getAllPosts,
  getFollowingPosts,
} from "../../redux/actions/postActions";
import { DEFAULT_HOME_PATH } from "../../utils/constents";
import { useIonRouter } from "@ionic/react";

const BlockPopup = () => {
  const dispatch = useDispatch();
  const { showBlockPopup, selectedFriend } = useSelector(
    (state) => state.friendModal,
  );
  const username = selectedFriend?.username || "";
  const router = useIonRouter();
  useEffect(() => {
    if (showBlockPopup && username) {
      fetch(`${SERVER_URL}/profile/block`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include", // Include cookies if needed
        body: JSON.stringify({ username }),
      })
        .then((res) => {
          if (!res.ok) throw new Error("Block failed");
          return res.json();
        })
        .then((data) => {
          console.log("Blocked user:", data);
        })
        .then(() => {
          // Optionally, refresh posts or user data
          dispatch(getAllPosts(1)); // Refresh all posts
          dispatch(getFollowingPosts(1)); // Refresh following posts
          // go to home page
          router.push(DEFAULT_HOME_PATH);
        })
        .catch((err) => {
          console.error("Error blocking user:", err.message);
        });

      const timer = setTimeout(() => {
        dispatch(resetFriendModalState());
      }, 3000); // 3 seconds

      return () => clearTimeout(timer); // cleanup if popup closes early
    }
  }, [showBlockPopup, dispatch, username, router]);

  if (!showBlockPopup) return null;

  return (
    <div className="block-popup">
      <div className="block-popup__content">
        <h3>User blocked</h3>
        <p>You won’t see posts or messages from this user anymore.</p>
      </div>
    </div>
  );
};

export default BlockPopup;

